export default {
  member_contacted_today: 'You have already sent this Member an Invitation to Connect. Please wait for a response or send a reminder after 24 hours.',
  same_gender: `You can't contact same gender.`,
  not_contacted: 'This member has not contacted you yet.',
  member_hidden: 'Your profile is currently hidden.',
  member_blocked: 'You have blocked this member.',
  profile_unblocked_today: 'Member can be Unblocked only after 48 hours.',
  password_request_sent: 'You have already sent this member a photo password request.',
  max_contact_limit_exceeded: 'You have exceeded your daily limit of 20 contact details views on Shaadi.com. Please try again tomorrow.',
  membership_contact_limit_exceeded:
    'You have exceeded the maximum limit of contact details that you can view on Shaadi.com. To continue viewing phone numbers, please Extend your Membership.',
  draft_limit_exceeded: 'You have already saved 5 Email Drafts. To create a new Draft, delete an existing one.',
  member_reminder_sent: 'Visit again after 24 hours to send a Reminder.',
  limit_exceeded: 'Invitation limit exceeded.',
  profile_blocked: 'This Member has hidden or deleted their profile.',
  member_declined: 'You have already Declined this Member.',
  member_accepted: 'You have already Accepted this Member.',
};
